import { Zap } from 'lucide-react';
import { useNavigate } from 'react-router';
import { Button } from '../ui/button';

export function UpgradePrompt({ feature, requiredPlan, description }) {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="w-16 h-16 rounded-[20px] bg-[var(--warning-muted)] flex items-center justify-center mb-4">
        <Zap size={28} className="text-[var(--warning)]" />
      </div>
      <h3 className="text-[17px] font-bold text-[var(--text-primary)] mb-1">{feature}</h3>
      <p className="text-[13px] text-[var(--text-secondary)] max-w-xs mb-1">{description}</p>
      <p className="text-[12px] font-semibold text-[var(--warning)] mb-5">Requires {requiredPlan} plan</p>
      <Button variant="outline" size="sm" onClick={() => navigate('/settings/plan')}>Upgrade Plan</Button>
    </div>
  );
}
export default UpgradePrompt;
